/* eslint-disable react/no-array-index-key,no-console */
import * as React from 'react';
import styled from 'styled-components';

import DashboardLayout from '../layouts/DashboardLayout';

import IncomeBlock from '../organisms/Dashboard/IncomeBlock';
import FAProposalGraph from '../organisms/Dashboard/FAProposalGraph';
import FAFranchiseSalesGraph from '../organisms/Dashboard/FAFranchiseSalesGraph';
import FATodayTaskWidget from '../organisms/Dashboard/FATodayTaskWidget';
import FADailyMessage from '../organisms/Dashboard/FADailyMessage';

const DashboardPageFA = () => {
  return (
    <DashboardLayout>
      <PageContainer>
        <TopRow>
          <IncomeBlock />
          <FATodayTaskWidget />
          <FADailyMessage />
        </TopRow>
        <BottomRow>
          <FAFranchiseSalesGraph />
          <FAProposalGraph />
        </BottomRow>
      </PageContainer>
    </DashboardLayout>
  );
};

const PageContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
  padding: 24px;
  box-sizing: border-box;
  width: 100%;
  font-family: 'Segoe UI', -apple-system, BlinkMacSystemFont,
    'Helvetica Neue', Arial, Roboto, sans-serif,
    'Apple Color Emoji', 'Segoe UI Emoji', 'Segoe UI Symbol';

  @media only screen and (max-width: 840px) {
    padding: 16px;
    gap: 16px;
  }

  @media only screen and (max-width: 540px) {
    padding: 12px;
    gap: 12px;
  }
`;

const TopRow = styled.div`
  display: grid;
  grid-template-columns: repeat(
    auto-fit,
    minmax(320px, 1fr)
  );
  gap: 20px;
  align-items: start;

  @media only screen and (max-width: 1150px) {
    grid-template-columns: 1fr;
    gap: 14px;
  }
`;

const BottomRow = styled.div`
  display: grid;
  grid-template-columns: repeat(
    auto-fit,
    minmax(420px, 1fr)
  );
  gap: 20px;
  align-items: start;

  @media only screen and (max-width: 1150px) {
    grid-template-columns: 1fr;
    gap: 14px;
  }
`;

export default DashboardPageFA;
